<!-- 图书柜-我要买书-商品列表 -->
<template>
  <div class="BookcaseGsList">
    <div class="searchArea">
      <!-- <input type="text" class="text" v-model="keywords" placeholder="请输入想要的商品的名字" /> -->
      <el-input class="text" v-model="keywords" placeholder="请输入想要的商品的名字" clearable></el-input>
      <span class="icon" @click="getCompanyProduct('search')"></span>
    </div>
    <div class="list-wrapper" v-if="list.length !== 0">
      <div class="list" v-for="(item, index) in list" :key="index" @click.self="goGoodsDetail(item)">
        <img class="cover" :src="item.image" alt="">
        <div class="detail">
          <p class="bTit">{{item.name}}</p>
          <p class="intro">简介：{{item.intro}}</p>
        </div>
        <p class="price">￥{{item.price}}</p>
        <div class="bbtnArea">
          <p class="bbtn bbtn-default mini" @click="goGoodsDetail(item)">详情</p>
          <p class="bbtn bbtn-p mini" @click="goOpenBox(item)">开箱</p>
        </div>
      </div>
    </div>
    <div class="noReserve two" v-else>
      <p class="text">当前无更多商品</p>
    </div>
  </div>
</template>

<script>
  import { messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  let vm

  export default {
    name:'BookcaseGsList',
    components: {
    },
    data() {
      return {
        keywords: '',
        list: []
      }
    },
    created() {
      vm = this
      vm.getCompanyProduct()
    },
    mounted () {
      console.log('this', this.$route)
    },
    methods: {
      // 获取当前设备下正在售卖的商品
      async getCompanyProduct (isSearch) {
        let data = {
          cabinet_id: config.deviceId
        }
        if (isSearch) { data.keywords = vm.keywords}

        showLoading('获取商品中')
        let res = await ECMallApi.getCompanyProduct(data)
        hideLoading()
        if (res.meta.code === 200) {
          vm.list = [...res.data]
        } else {
          messageError(res.meta.message)
        }
      },
      // 去商品详情
      goGoodsDetail (item) {
        vm.$store.state.ECMall_activeGoods = item
          vm.$store.state.ECMall_pageSource = 'GoodsList'
        vm.$router.push('/Bookcase/GoodsDetail')
      },
      // 去开箱
      goOpenBox (item) {
        vm.openBox(item)
      },
      // 开箱门(买书开箱取物为3)
      async openBox (item) {
        let data = {
          type: 3,
          cabinet_id: config.deviceId,
          pid: item.pid
        }

        // console.log(data)
        let res = await ECMallApi.openBox(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log(res)
          vm.$store.state.ECMall_activeGoods = item
          vm.$store.state.ECMall_pageSource = 'GoodsList'
          vm.$router.push('/Bookcase/BScanCode')
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },
    },
    watch: {
      'keywords' (newVal) {
        if (newVal === '') {
          vm.getCompanyProduct()
        }
      }
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseGsList {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .searchArea{
      flex-shrink: 0;
      width: 8.8rem;
      height: 0.7rem;
      margin: 0.3rem auto 0;
      border-radius: 0.35rem;
      background-color: #e8e8e8;
      position: relative;
      .text {
        width: 7.6rem;
        height: inherit;
        line-height: inherit;
        padding-left: 0.39rem;
        // padding-right: 0.8rem;
        font-size: 0.32rem;
        color: #999999;
        input {
          width: 100%;
          height: inherit;
          line-height: inherit;
          background-color: transparent;
          border-color: transparent;
          padding: 0;
        }
        .el-input__clear {
          font-size: 0.34rem;
          line-height: inherit;
        }
      }
      .icon {
        display: block;
        width: 0.29rem;
        height: 0.29rem;
        background: url(/static/Bookcase/images/icon_search.png) center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.49rem;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .list-wrapper {
      width: 100%;
      height: 100%;
      padding:  0 0.44rem;
      margin: 0.3rem 0;
      overflow-x: hidden;
      overflow-y: scroll;
      .list {
        width: 100%;
        padding: 0.28rem 0.96rem 0.3rem 0.29rem;
        margin-top: 0.3rem;
        background-color: #ffffff;
        border-radius: 0.05rem;
        box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
        position: relative;
        display: flex;
        &:first-child {
          margin-top: 0;
        }
        .cover{
          flex-shrink: 0;
          width: 1.5rem;
          height: 2rem;
          margin-right: 0.3rem;
        }
        .detail {
          .bTit {
            margin-top: 0.12rem;
            font-size: 0.34rem;
            line-height: 1;
            font-weight: bold;
          }
          .intro {
            height: 0.64rem;
            margin: 0.22rem 0 0.3rem;
            font-size: 0.24rem;
            line-height: 0.32rem;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .price {
          font-size: 0.34rem;
          line-height: 1;
          font-weight: bold;
          color: #d72f2f;
          position: absolute;
          right: 1.03rem;
          top: 0.43rem;
        }
        .bbtnArea {
          display: flex;
          position: absolute;
          right: 0.4rem;
          bottom: 0.26rem;
          z-index: 10;
          .bbtn {
            width: 1.8rem;
            &+.bbtn {
              margin-left: 0.15rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Buy/GoodsList.vue